<template>
  <div
    class="cta-area cta-three bg-cover"
    data-background="/assets/img/cta_bg.png"
  >
    <div class="overlay"></div>
    <div class="cta-area-inner pt-50">
      <div class="container">
        <div class="offset-xl-2 col-xl-6 offset-lg-1 col-lg-6 col-md-8">
          <div class="section-title">
            <p>GET STARTED</p>
            <h2 class="text-white">
              Your Partner in Compliance & Financial Growth
            </h2>
          </div>
          <router-link :to="{ name: 'Contact' }" class="main-btn mt-20"
            >Contact Us Today</router-link
          >
        </div>

        <div
          class="offset-xl-4 col-xl-7 offset-lg-4 col-lg-7 offset-md-4 col-md-7"
        >
          <p class="text-white">
            Ready to simplify your tax and accounting requirements? Let our qualified professionals 
            help you stay compliant while achieving financial clarity and growth. Contact us today 
            for a consultation.
          </p>
        </div>

        <div class="pop-up-video">
          <a
            href="https://www.youtube.com/watch?v=yFwGpiCs3ss"
            class="video-play-btn mfp-iframe"
          >
            <i class="las la-play"></i> <span></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CTA2",
  mounted() {
    //Magnific Pop-up

    $(".video-play-btn").magnificPopup({
      type: "iframe",
    });
  },
};
</script>
